export default "<div class=\"col-md-12 col-lg-12 col-xl-12\">\r\n  <div style=\"width: 100%;\" [id]='contenedor' [class]='sombreado'>\r\n  </div>\r\n</div>\r\n"